<template>
    <div class="row">
        <div class="col">
            <div class="d-flex align-items-end mb-3">
                <h4 class="mb-0">
                    {{ $tc('models.asset') }}:
                </h4>
                <span class="text-muted ml-1">{{ model.name }}</span>
            </div>

            <div>
                <div class="flex-row">
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t('asset.description') }}:
                        </span>

                        {{ model.description || `(${$t('defaults.none')})` }}
                    </div>
                </div>
                <div class="flex-row">
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t('asset.tracking-number') }}:
                        </span>

                        {{ model.tracking_number || `(${$t('defaults.none')})` }}
                    </div>
                </div>
                <div class="flex-row">
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t('asset.serial-number') }}:
                        </span>

                        {{ model.serial_number || `(${$t('defaults.none')})` }}
                    </div>
                </div>
            </div>

            <hr>

            <div>
                <div
                    v-for="(d, index) in assetData"
                    :key="index"
                    class="flex-row"
                >
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t(d.title) }}:
                        </span>

                        <currency
                            v-if="d.isCurrency"
                            v-model="d.value"
                        />

                        <span v-else>
                            {{ d.value || `(${$t('defaults.none')})` }}
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="model.messages && model.messages.length">
                <messages-message-grid
                    v-for="item in model.messages"
                    :id="`asset-message-${item.id}`"
                    :key="item.id"
                    :item="convertToMessage(item)"
                    @refresh="$emit('store')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Show from '@/mixins/Show';
import Message from '@/models/Message';
import store from '@/store';

export default {
    mixins: [Show],
    data () {
        return {
            loading: false,
        };
    },
    computed: {
        assetData () {
            return [
                {
                    title: 'models.client',
                    value: this.model.client?.full_name,
                },
                {
                    title: 'models.company',
                    value: this.model.company?.name,
                },
                {
                    title: 'asset.warranty-until',
                    value: this.model.warranty_until ? this.$dayjs(this.model.warranty_until).format('DD MMM YY') : `(${this.$t('defaults.none')})`,
                },
            ];
        },
        store () {
            return store;
        },
    },
    methods: {
        convertToMessage (object) {
            const msg = new Message(object);
            msg.message = Message.replaceMessageAttachmentUrls(msg.message);

            return msg;
        },
    },
};
</script>
